export enum ConsumptionTimeframe {
  DAY = 'DAY',
  MONTH = 'MONTH',
  QUARTER = 'QUARTER',
  YEAR = 'YEAR',
  MAX = 'MAX',
}
